// extracted by mini-css-extract-plugin
export default {"tooltip":"AX-z","arrow":"BX-z"};